module.exports = __webpack_public_path__ + "img/banner-1.eaa964d9.png";